import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "../common-components";
import { PasswordForgotComponent } from "./password-forgot/password-forgot.component";
import { RouterModule } from '@angular/router';
import { PasswordResetComponent } from './password-reset/password-reset.component';

@NgModule({
  imports: [CommonComponentsModule, RouterModule],
  declarations: [PasswordForgotComponent, PasswordResetComponent],
  exports: [PasswordForgotComponent, PasswordResetComponent],
})
export class CstPasswordModule {}
